import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="">
        <div className="footer-section">
          <div className="upper-section">
            <div className="footer-content">
              <div className="footer-list-container">
                <div className="footer-list">
                  <div className="links-list">
                    <h3>Pocketvila</h3>
                    <ul>
                      <li>
                        <a href="#" title="About Us">
                          About Us
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Support">
                          Support
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Contact Us">
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Help Centre">
                          Help Centre
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Careers">
                          Careers
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Blog">
                          Blog
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Offers">
                          Offers
                        </a>
                      </li>

                      <li>
                        <Link to="/privacy-policy" title="Privacy Policy">
                          Privacy Policy
                        </Link>
                      </li>

                      <li>
                        <Link to="/terms-conditions" title="Terms & Conditions">
                          Terms &amp; Conditions
                        </Link>
                      </li>

                      <li>
                        <Link to="/refund-policy" title="Refund Policy">
                          Refund Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="footer-list footer-list-2">
                  <div className="links-list">
                    <h3>Financial Services</h3>
                    <ul>
                      <li>
                        <a href="#" title="Pay Insurance Premium">
                          Pay Insurance Premium
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Fixed Deposit">
                          Fixed Deposit
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Credit Card">
                          Credit Card
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Loans">
                          Loans
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Loan Repayment">
                          Loan Repayment
                        </a>
                      </li>
                      <li>
                        <a href="#" title="UPI">
                          UPI
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="footer-list footer-list-2">
                  <div className="links-list">
                    <h3>Recharge &amp; Pay Bills</h3>
                    <ul>
                      <li className="single-list">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Mobile Recharge
                          </span>
                          <div
                            id="mobile-recharge"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "10px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="Airtel Mobile Recharge">
                                      Airtel Mobile Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="BSNL Mobile Recharge">
                                      BSNL Mobile Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Jio Mobile Recharge">
                                      Jio Mobile Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      title="MTNL Delhi Mobile Recharge"
                                    >
                                      MTNL Delhi Mobile Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      title="MTNL Mumbai Mobile Recharge"
                                    >
                                      MTNL Mumbai Mobile Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Vi Mobile Recharge">
                                      Vi Mobile Recharge
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a href="#" title="FASTag Recharge">
                          FASTag Recharge
                        </a>
                      </li>
                      <li className="single-list">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Mobile Bill Payment
                          </span>
                          <div
                            id="mobile-bill payment"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="Airtel Bill Payment">
                                      Airtel Bill Payment
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="BSNL Bill Payment">
                                      BSNL Bill Payment
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Jio Bill Payment">
                                      Jio Bill Payment
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Vi Bill Payment">
                                      Vi Bill Payment
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Electricity North
                          </span>
                          <div
                            id="electricity-north"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="WBSEDCL">
                                      WBSEDCL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="CESC">
                                      CESC
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="JVVNL">
                                      JVVNL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="PGVCL">
                                      PGVCL
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="BSES Rajdhani">
                                      BSES Rajdhani
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="MPPKVVCL - Jabalpur">
                                      MPPKVVCL - Jabalpur
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="CSPDCL">
                                      CSPDCL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="SBPDCL">
                                      SBPDCL
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Electricity South
                          </span>
                          <div
                            id="electricity-south"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="MSEDCL">
                                      MSEDCL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="APEPDCL">
                                      APEPDCL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="BESCOM">
                                      BESCOM
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="TNEB">
                                      TNEB
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="APCPDCL">
                                      APCPDCL
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="APSPDCL">
                                      APSPDCL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Adani Electricity">
                                      Adani Electricity
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="KSEBL">
                                      KSEBL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="BEST Mumbai">
                                      BEST Mumbai
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Tata Power - Mumbai">
                                      Tata Power - Mumbai
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="single-list">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            DTH
                          </span>
                          <div
                            id="dth"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="Airtel DTH Recharge">
                                      Airtel DTH Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="D2H DTH Recharge">
                                      D2H DTH Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Dish TV DTH Recharge">
                                      Dish TV DTH Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Sun Direct DTH Recharge">
                                      Sun Direct DTH Recharge
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Tata Play DTH Recharge">
                                      Tata Play DTH Recharge
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul>
                      <li className="">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Piped Gas
                          </span>
                          <div
                            id="piped-gas"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="Gujarat Gas Limited">
                                      Gujarat Gas Limited
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="MGL">
                                      MGL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="IGL">
                                      IGL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Adani Gas">
                                      Adani Gas
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Sabarmati Gas">
                                      Sabarmati Gas
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="MNGL">
                                      MNGL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="VGL">
                                      VGL
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Aavantika Gas Ltd">
                                      Aavantika Gas Ltd
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Charotar Gas">
                                      Charotar Gas
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a href="#" title="Book a Cylinder">
                          Book a Cylinder
                        </a>
                      </li>
                      <li className="">
                        <div className="tooltip-wrapper footer-tooltip">
                          <span className="tooltip-label tooltip-show-arrow">
                            Water
                          </span>
                          <div
                            id="water"
                            className="tooltip-content-wrapper hidden"
                            style={{
                              top: "0px",
                              left: "0px",
                              paddingLeft: "0px",
                            }}
                          >
                            <div className="tooltip">
                              <span className=""></span>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="BWSSB">
                                      BWSSB
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Rajasthan PHED">
                                      Rajasthan PHED
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="DJB">
                                      DJB
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="KWA">
                                      KWA
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Goa PWD">
                                      Goa PWD
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="links-list">
                                <ul>
                                  <li>
                                    <a href="#" title="HMWSSB">
                                      HMWSSB
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      title="Uttarakhand Jal Sansthan"
                                    >
                                      Uttarakhand Jal Sansthan
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Mizoram PHED">
                                      Mizoram PHED
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      title="Municipal Corp. Chandigarh"
                                    >
                                      Municipal Corp. Chandigarh
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a href="#" title="Municipal Tax">
                          Municipal Tax
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Landline">
                          Landline
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Broadband">
                          Broadband
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="download-and-follow">
                  <h3>Download Pocketvila App</h3>
                  <div className="download-app-content">
                    <div className="app-qr-code">
                      <img
                        src="assets/pwa-static/pwa/images/qr-01.gif"
                        alt="Freecharge Qr"
                      />
                      <p className="scan-text">Scan to download</p>
                    </div>
                    <div className="app-links">
                      <div className="images-list">
                        <a href="https://play.google.com/store/apps/details?id=com.solution.pocketvila&hl=en_IN">
                          <img
                            className="google-play"
                            src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/download-app-play-store.svg"
                            alt="google play image"
                            title="Google Play Store"
                            loading="lazy"
                          />
                        </a>
                        <a href="https://itunes.apple.com/us/app/recharge-mobile-dth-online/id877495926">
                          <img
                            className="app-store"
                            src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/download-app-ios.svg"
                            alt="app store image"
                            title="App Store"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="app-links">
                      <div className="images-list">
                        <a href="#"></a>
                        <a href="#"></a>
                      </div>
                    </div>
                  </div>
                  <div className="social-medias-links">
                    <h3>Follow Us</h3>
                    <div className="images-list">
                      <a href="#">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/facebook.svg"
                          alt="fb image"
                          title="Facebook"
                          loading="lazy"
                        />
                      </a>
                      <a href="#">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/linkedin.svg"
                          alt="linkedin image"
                          title="LinkedIn"
                          loading="lazy"
                        />
                      </a>
                      <a href="#">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/twitter.svg"
                          alt="twitter image"
                          title="Twitter"
                          loading="lazy"
                        />
                      </a>
                      <a href="#">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/youtube.svg"
                          alt="youtube image"
                          title="Youtube"
                          loading="lazy"
                        />
                      </a>
                      <a href="#">
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/footer/instagram.svg"
                          alt="instagram image"
                          title="Instagram"
                          loading="lazy"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div className="seo-links-section footer-list-2">
            <div className="seo-links">
              <h3>Popular Billers on Pocketvila</h3>
              <div className="link-group">
                <p className="list-heading">Electricity Bill Payment</p>
                <a href="#">WBSEDCL</a>
                <a href="#">msedcl</a>
                <a href="#">pspcl</a>
                <a href="#">tneb</a>
                <a href="#">uhbvn</a>
                <a href="#">apdcl</a>
                <a href="#">apepdcl</a>
                <a href="#">kesco</a>
                <a href="#">bescom</a>
                <a href="#">ugvcl</a>
                <a href="#">Adani Electricity</a>
                <a href="#">mgvcl</a>
              </div>
              <div className="link-group">
                <p className="list-heading">DTH Recharge</p>
                <a href="#">tataplay (formely known as Tatasky)</a>
                <a href="#">sun direct</a>
                <a href="#">airtel DTH</a>
                <a href="#">dish tv</a>
                <a href="#">d2h DTH</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Piped Gas</p>
                <a href="#">mahanagar gas</a>
                <a href="#">igl</a>
                <a href="#">adani gas</a>
                <a href="#">torrent gas</a>
                <a href="#">avantika gas</a>
                <a href="#">gujarat gas</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Landline</p>
                <a href="#">airtel</a>
                <a href="#">bsnl Corporate</a>
                <a href="#">bsnl Consumer</a>
                <a href="#">mtnl delhi</a>
                <a href="#">mtnl mumbai</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Mobile Recharge</p>
                <a href="#">airtel recharge</a>
                <a href="#">bsnl recharge</a>
                <a href="#">jio recharge</a>
                <a href="#">vi recharge</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Mobile Postpaid</p>
                <a href="#">BSNL Postpaid</a>
                <a href="#">Jio Postpaid</a>
                <a href="#">Airtel Postpaid</a>
                <a href="#">VI Postpaid</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Cylinder Booking</p>
                <a href="#">Bharat Gas</a>
                <a href="#">HP Gas</a>
                <a href="#">Indane Gas</a>
              </div>
              <div className="link-group">
                <p className="list-heading">FASTag</p>
                <a href="#">SBI FASTag</a>
                <a href="#">ICICI FASTag</a>
                <a href="#">IHMCL FASTag</a>
                <a href="#">Paytm FASTag</a>
                <a href="#">Equitas FASTag</a>
                <a href="#">Federal FASTag</a>
                <a href="fastag-recharge/hdfc-bank.html">HDFC FASTag</a>
                <a href="#">AXIS FASTag</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Water</p>
                <a href="#">BWSSB</a>
                <a href="#">DJB</a>
                <a href="#">HMWSSB</a>
              </div>
              <div className="link-group">
                <p className="list-heading">Broadband</p>
                <a href="#">airtel broadband</a>
                <a href="#">kerala vision broadband</a>
                <a href="#">act fibernet</a>
              </div>
              <hr />
            </div>
          </div>
          <div className="lower-section">
            <div className="lower-section-content">
              <p className="text-content">
                © AYYUN TELE SERVICES PRIVATE LIMITED. All Rights Reserved |
                Pocketvila Balance Account (Prepaid Payment Instrument) issued
                by{" "}
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="pop-up-wrapper swipe-bottom secondary-layout">
        <div
          className="pop-up  "
          style={{
            maxWidth: "909px",
            maxHeight: "720px",
            minWidth: "909px",
            minHeight: "475px",
          }}
        ></div>
      </div>
    </>
  );
};

export default Footer;
